/**
 * Shared contact tracking for HIMML Bestattungen and HIMML Vorsorge.
 * Imported by src/bundle.js and compiled with the theme by Parcel.
 */
(() => {
  "use strict";

  if (window.himmlContactTrackingLoaded) return;
  window.himmlContactTrackingLoaded = true;

  // Add new HIMML numbers here in international format, in both theme copies.
  const ownPhoneNumbers = new Set([
    "+4992165559", // Bestattungen: Bayreuth.
    "+499217577144", // Vorsorge: Bayreuth.
    "+499277975581", // Warmensteinach.
    "+4992736277", // Goldkronach.
    "+499203306", // Neudrossenfeld.
    "+49921530404611", "+4992153040411", "+4915114845022",
    "+4915114845027",
    "+49921530404612", "+4992153040412",
    "+49921530404614", "+4992153040414",
    "+49921530404615", "+4992153040415", "+4915114845026",
    "+491704749895",
    "+49921530404623", "+4992153040423",
    "+49921530404620", "+4992153040420",
    "+4915114845028",
  ]);
  const ownEmailDomains = new Set([
    "himml-bestattungen.de",
    "himml-vorsorge.de",
  ]);
  const serviceNumbers = new Set(["110", "112", "116117"]);
  const legacyContactClass =
    /^plausible-event-name(?:=|--)(?:phoneclick|emailclick|externalcontactclick)$/i;

  function decode(value) {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  function normalizePhone(value) {
    let number = decode(value.split(/[;?#]/)[0]).replace(/[^\d+]/g, "");
    if (number.startsWith("00")) number = "+" + number.slice(2);
    else if (number.startsWith("0")) number = "+49" + number.slice(1);
    return number.replace(/^\+490/, "+49");
  }

  function decodeEmail(value) {
    return value.replace(/\[at\]/gi, "@").replace(/[a-z]/gi, (character) => {
      const start = character <= "Z" ? 65 : 97;
      return String.fromCharCode((character.charCodeAt(0) - start + 13) % 26 + start);
    });
  }

  function getContact(link) {
    const href = (link.getAttribute("href") || "").trim();
    if (/^tel:/i.test(href)) {
      const number = normalizePhone(href.slice(4));
      if (!number) return null;
      return {
        type: "phone",
        own: ownPhoneNumbers.has(number),
        ignored: serviceNumbers.has(number.replace(/^\+49/, "")),
      };
    }

    const encodedEmail = link.getAttribute("data-enc-email");
    let email;
    if (/^mailto:/i.test(href)) {
      // Never include subject, message body or other mailto parameters in analytics.
      email = decode(href.slice(7).split("?")[0]);
    } else if (encodedEmail) {
      email = decodeEmail(encodedEmail).split("?")[0];
    } else {
      return null;
    }

    const recipients = email.toLowerCase().split(/[,;]/).map((item) => item.trim()).filter(Boolean);
    if (!recipients.length) return null;
    return {
      type: "email",
      own: recipients.every((recipient) => ownEmailDomains.has(recipient.split("@")[1])),
      ignored: false,
    };
  }

  function trackContact(event) {
    if (event.type === "auxclick" ? event.button !== 1 : event.button > 0) return;

    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = target?.closest("a");
    if (!link) return;
    const contact = getContact(link);
    if (!contact) return;

    // Plausible's class handler runs in the bubble phase. Remove only legacy
    // contact-event names from this click path before it runs, preventing a
    // second event. Saved WordPress content and other custom goals stay intact.
    for (let element = target; element; element = element.parentElement) {
      for (const className of Array.from(element.classList)) {
        if (legacyContactClass.test(className)) element.classList.remove(className);
      }
    }

    if (contact.ignored || link.closest(".himml-no-contact-tracking")) return;
    // Use the existing plugin instance/queue and its exclusions. Never initialize
    // Plausible ourselves or bypass disabled tracking for logged-in editors.
    if (typeof window.plausible !== "function") return;

    const position = link.closest("header") ? "header" : link.closest("footer") ? "footer" : "content";
    const props = { position };
    const name = contact.own ? contact.type + "click" : "externalcontactclick";
    if (!contact.own) props.type = contact.type;

    window.plausible(name, { props });
  }

  // Delegation also covers new blocks, mobile menus and nested SVG/icon clicks.
  // Keyboard activation and touch taps generate click events without extra handlers.
  document.addEventListener("click", trackContact, true);
  document.addEventListener("auxclick", trackContact, true);
})();
